// src/hooks/useServiceList.js 등 원하는 위치에 생성
import { useEffect, useState, useContext } from "react";
import axios from "../../utils/api/axios";
import { IAM_SERVER_SERVICE } from "../Config";
import { AuthContext } from "../contextapi/AuthProvider";

export function useServiceList(tenantId) {
    const [serviceList, setServiceList] = useState([]);
    // const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const {role, user} = useContext(AuthContext);

    useEffect(() => {

        const userId = user.email;

        //role SYS_ADMIN 일경우에만 전체 조회
        //SERVICE_ADMIN만 있을경우 해당 유저의 ID로 자신이 생성한 serivce만 조회
        let conditions = [];
        if (role && Array.isArray(role)) {
            if (role.includes("SYS_ADMIN")) {
                // SYS_ADMIN은 전체 조회 (조건 X)
                conditions = [];
            } 
            else if (role.includes("SERVICE_ADMIN")) {
                // SERVICE_ADMIN이면 자기 자신이 생성한 서비스만 조회
                conditions = [
                    { field: "createdBy", operator: "EQUALS", value: tenantId }
                ];
            } else {
                // 기타 권한이면 서비스 조회 못하게 (예시, 필요시 else 삭제)
                conditions = [{ field: "createdBy", operator: "EQUALS", value: tenantId }];
            }
        }

                //         conditions = [
                //     { field: "createdBy", operator: "EQUALS", value: userId }
                // ];

        const params = {
            sortField: ["serviceName"],
            sortOrder: ["asc"],
            operator: "AND",
            conditions
        };


        axios.post(IAM_SERVER_SERVICE + "/all", params)
            .then(res => {
                setServiceList(res.data.data.data);
            })
            .catch(err => {
                setError(err);
            });
    }, []);

    return { serviceList };
}